var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userInfo",on:{"click":_vm.toUserInfo}},[_c('img',{staticClass:"touxiang",attrs:{"src":require("@/assets/user_img.png"),"alt":""}}),_c('div',{staticClass:"info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.item.username))]),_c('div',{staticClass:"country"},[_vm._v(" "+_vm._s(_vm.departName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }